import React from 'react';
import SplitMapComparison from './SplitMapComparison';
import { useBusiness } from '../../contexts/BusinessContext';

const ComparisonMode = ({ 
  selectedKeyword, 
  rankingHistory = [], 
  onCreateSnapshot,
  loading = false 
}) => {
  const { selectedBusiness } = useBusiness();

  return (
    <SplitMapComparison
      selectedKeyword={selectedKeyword}
      rankingHistory={rankingHistory}
      businessLocation={selectedBusiness}
      onCreateSnapshot={onCreateSnapshot}
      loading={loading}
    />
  );
};

export default ComparisonMode;